var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"living-options-packages"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"packages"},[_c('h3',[_vm._v("Packages")]),_c('button',{staticClass:"btn btn-sm btn-primary mb-4",on:{"click":_vm.addPackage}},[_vm._v("Add Package")]),_c('div',{staticClass:"mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.packageFilterText),expression:"packageFilterText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filter packages"},domProps:{"value":(_vm.packageFilterText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.packageFilterText=$event.target.value}}})]),_c('v-table',{attrs:{"columns":[
            { 
              label: 'Label',
              field: 'label',
            },
            { 
              label: 'Lot',
              field: 'property.label',
              options: {
                sortable: true,
                callback: function(row) {
                  _vm.navToLot(row)
                },
              }
            },
            { 
              label: 'House', 
              field: 'dwelling.label', 
              options: {
                sortable: true,
                callback: function(row) {
                  _vm.navToDwelling(row)
                },
                return: function (fieldValue) {
                  return fieldValue
                }
              }
            },
            {
              label: 'Price',
              field: 'price',
              options: {
                sortable: true,
                return: function (fieldValue) {
                  if (!fieldValue) {
                    return '-'
                  } else {
                    return fieldValue.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', maximumSignificantDigits: 10 })
                  }
                },
              }
            } ],"rows":_vm.filteredPackages,"show-active-toggle":_vm.activeUser.access.indexOf('live-toggle') !== -1,"save-action":"SAVE_PACKAGE"},on:{"edit":function($event){return _vm.editPackage($event._id)},"clone":function($event){return _vm.clonePackage($event)},"delete":function($event){return _vm.deletePackage($event._id)}}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }